import { Planzone, Identifiable, ProjectExpenseType } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveProjectExpenseType(httpClient: HttpClient) {
  return (
    planzone: Identifiable<Planzone>,
    projectExpenseType: ProjectExpenseType,
  ) =>
    new Promise<Identifiable<ProjectExpenseType>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<ProjectExpenseType>>({
          endpoint: "/expenseTypes",
          method: HttpMethods.POST,
          data: {
            planzone: `planzone/${planzone.uuid}`,
            ...projectExpenseType,
          },
        })
        .then((projectExpenseType) => projectExpenseType)
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { saveProjectExpenseType };
